






































































// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { UserDropdown } from "@/components.nav/user-dropdown";
import { GlobalAdd } from "@/components.nav/global-add";

export default defineComponent({
	props:{
		menuState:{
			type:Boolean,
			default:true
		}
	},
	components: {
		UserDropdown,
		GlobalAdd,
	},
	setup(props, context){

		const openMenu = () => {
			context.emit("open-menu");
		};

		return {
			openMenu
		}
	}
});

